import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { PatientDailyReportListComponent } from 'src/app/shared/patient-daily-report/patient-daily-report-list.component';
import { IPatientDailyReport, PatientDailyReportContext } from 'src/app/shared/patient-daily-report/patient-daily-report.types';

@Component({
  selector: 'app-day-to-day',
  imports: [CommonModule, MaterialModule, TranslateModule, TablerIconsModule, PatientDailyReportListComponent],
  templateUrl: './day-to-day.component.html',
  styleUrl: './day-to-day.component.scss',
})
export class DayToDayComponent {
  reports: IPatientDailyReport[] = [];

  constructor(
    @Optional() private dialogRef: MatDialogRef<DayToDayComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: PatientDailyReportContext
  ) {}

  onReportsChanged(reports: IPatientDailyReport[]): void {
    this.reports = reports;
  }

  close(): void {
    this.dialogRef?.close(this.reports);
  }
}
